import React from "react";

export const VcbBankerSalePerformanceHeader = (props) => {
    return (
        <>
            <thead className={"bp-report-thead"}>
            <tr className={"bp-report-thead-tr"}>
                <th rowSpan={2} className={"bp-report-thead-th"}>Cây báo cáo</th>
                <th rowSpan={2} className={"bp-report-thead-th"}>Phân Loại</th>
                <th rowSpan={2} className={"bp-report-thead-th"}>SL HĐ Phát Hành</th>
                <th rowSpan={2} className={"bp-report-thead-th"}>Active</th>
                <th colSpan={4} className={"bp-report-thead-th"}>FYP Lũy Kế Tháng</th>
                <th colSpan={4} className={"bp-report-thead-th"}>FYP Lũy Kế Năm</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th colSpan={1}>Mô Hình Giới Thiệu</th>
                <th colSpan={1}>Mô Hình Online</th>
                <th colSpan={1}>Bảo Hiểm Tín Dụng</th>
                <th colSpan={1}>Mô Hình Giới Thiệu + Online + Credit</th>
                <th colSpan={1}>Mô Hình Giới Thiệu</th>
                <th colSpan={1}>Mô Hình Online</th>
                <th colSpan={1}>Bảo Hiểm Tín Dụng</th>
                <th colSpan={1}>Mô Hình Giới Thiệu + Online + Credit</th>
            </tr>

            </thead>
        </>
    )
}

export default  VcbBankerSalePerformanceHeader;